import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import {
  CreatePrData,
  PrListFilters,
  TableListResponseValueWithFilters
} from '../models';
import { BaseResponse, TablePagination } from '@app/shared/models';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrListService {
  private readonly baseUrl = environment.prDataApi;

  constructor(private http: HttpClient) {}

  public getPrList(
    filters: PrListFilters & TablePagination
  ): Observable<BaseResponse<TableListResponseValueWithFilters>> {
    return this.http.post<BaseResponse<TableListResponseValueWithFilters>>(
      `${this.baseUrl}/purchaseRequest/getPrs`,
      filters
    );
  }

  public removePrs(ids: string[]): Observable<void> {
    const params = { ids };

    return this.http.delete<void>(`${this.baseUrl}/PurchaseRequest/DeletePrs`, {
      params
    });
  }

  public createPr(data: CreatePrData): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(
      `${this.baseUrl}/purchaseRequest/createPr`,
      data
    );
  }
}
